import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { callsApi } from '../api/callsApi';
import { callsKeys } from '../queryKeys';

// Dashboard-vs-Retell drift and agents that can't take calls. Hits Retell per
// live number, so it's cached for a few minutes rather than refetched on focus.
export function useAgentHealth() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';

  const query = useQuery({
    queryKey: callsKeys.health(locationId),
    queryFn: () => callsApi.getAgentHealth(locationId),
    enabled: !!locationId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return { issues: query.data ?? [], isLoading: query.isLoading, isError: query.isError };
}
